//libraries
import Vue from 'vue'
import axios from 'axios'

let resource = 'account_attribute'
let resource_name = 'variable global'
let resource_name_plural = 'variables globales'

let state = {
  lastUpdate: null
}

state[resource + 's'] = []

//functions receive state
let getters = {

}

//functions receive context and params
let actions = {
  async all ({ commit, state }, params) {
    try {
      if (canUpdate(state.lastUpdate) || params.forceUpdate == true) {
        commit('setLastUpdate')
      } else {
        if(params.callback)
          params.callback({ success: true, resource: state.account_attributes })

        return
      }

      commit('setItems', [])
      let res = await Vue.request.get(`account/${params.account_id}/${resource}s`, {params: params.params || {}})
      if(res.data.success) {
        commit('setItems', res.data.resource.map(a => {
          if (a.frontend_type && a.frontend_type == 'input_number') {
            try {
              a.value = parseFloat(a.value)
            } catch (e) {
              a.value = 0
            }
          }
          a.edited = false
          a.show = false
          a.error = false
          return a
        }))
        if(params.callback)
          params.callback(res.data)
      } else {
        if(params.callback)
          params.callback({error: `Error obteniendo ${resource_name_plural}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error obteniendo ${resource_name_plural}.`})
      console.error(e)
    }
  },
  async get ({ commit }, params) {
    try {
      let res = await Vue.request.get(`${resource}/${params[resource + '_id']}`, {params: params.params || {}})
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error obteniendo ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error obteniendo ${resource_name}.`})
      console.error(e)
    }
  },
  async create ({ commit }, params) {
    try {
      let res = await Vue.request.post(`${resource}`, params)
      if(res.data.success) {
        let item = res.data.resource
        if (item.frontend_type && item.frontend_type == 'input_number') {
          try {
            item.value = parseFloat(a.value)
          } catch (e) {
            item.value = 0
          }
        }
        item.edited = false
        item.show = false
        item.error = false
        commit('pushItem', item)
        if(params.callback)
          params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error creando ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error creando ${resource_name}.`})
      console.error(e)
    }
  },
  async update ({ commit }, params) {
    try {
      let res = await Vue.request.patch(`${resource}/${params[resource + '_id']}`, params)
      if(res.data.success) {
        let item = res.data.resource
        if (item.frontend_type && item.frontend_type == 'input_number') {
          try {
            item.value = parseFloat(a.value)
          } catch (e) {
            item.value = 0
          }
        }
        item.edited = false
        item.show = false
        item.error = false
        commit('updateItem', item)
        if(params.callback)
          params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error actualizando ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error actualizando ${resource_name}.`})
      console.error(e)
    }
  },
  async destroy ({ commit }, params) {
    try {
      let res = await Vue.request.delete(`${resource}/${params[resource + '_id']}`, {data: params})
      if(res.data.success && params.callback) {
        commit('removeItem', params)
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error eliminando ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error eliminando ${resource_name}.`})
      console.error(e)
    }
  }
}

var canUpdate = function (lastUpdate) {
  if (lastUpdate) {
    let ellapsedMinutes = Vue.prototype.$moment().diff(lastUpdate, 'minutes')
    return ellapsedMinutes >= 1
  }

  return true
}

//functions receive state
let mutations = {
  setItems (state, items) {
    state[resource + 's'] = items
  },
  pushItem (state, item) {
    state[resource + 's'].push(item)
  },
  updateItem (state, item) {
    let index = state[resource + 's'].findIndex(i => i[resource + '_id'] == item[resource + '_id'])
    if (index >= 0) {
      state[resource + 's'].splice(index, 1, item)
    }
  },
  removeItem (state, item) {
    let index = state[resource + 's'].findIndex(i => i[resource + '_id'] == item[resource + '_id'])
    if (index >= 0) {
      state[resource + 's'].splice(index, 1)
    }
  },
  setLastUpdate (state) {
    state.lastUpdate = Vue.prototype.$moment()
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}
